import { ActivatedRoute, Router } from '@angular/router';

import { URLFormParams, formParamsToString } from 'ish-core/utils/url-form-params';

function isProductListingAllowed(searchParameter: URLFormParams): boolean {
  const object: Object[] = Object.keys(searchParameter);
  let threshold = 0;
  object.forEach(key => {
    if (key === 'productFilter' || key === 'category') {
      threshold += 1;
    }
  });
  return object.length > threshold;
}

function generateCategoryURL(params: string): string {
  const parsedParam = params.split('&category=');
  if (parsedParam[1]) {
    return `/c/${decodeURIComponent(parsedParam[1]).split('/').join('.')}`;
  }
  return '';
}

/**
 * DIAS custom functions for filter navigation
 *
 * @param event Search Parameter
 */

export function applyFilterNavigationHandler(
  event: { searchParameter: URLFormParams },
  router: Router,
  activatedRoute: ActivatedRoute
) {
  const allowProductListing = isProductListingAllowed(event.searchParameter);
  const searchParam = formParamsToString(event.searchParameter);
  const searchTerm: string | string[] | undefined = event.searchParameter?.searchTerm;
  let filterParam: string;
  let isRefined: boolean;

  if (searchTerm) {
    router.navigate([], {
      queryParamsHandling: 'merge',
      relativeTo: activatedRoute,
      queryParams: { filters: searchParam, page: 1 },
      //fragment: fragmentOnRouting,
    });
  } else {
    if (allowProductListing) {
      isRefined = true;
      filterParam = searchParam;
    }
    const categoryUrl = generateCategoryURL(searchParam);

    const navigationOptions = {
      replaceUrl: !allowProductListing,
      relativeTo: activatedRoute,
    };

    router.navigate([categoryUrl], {
      ...navigationOptions,
      ...(categoryUrl !== '' && {
        queryParamsHandling: 'merge',
        queryParams: { filters: filterParam, isRefinement: isRefined, page: 1 },
        // fragment: fragmentOnRouting,
      }),
    });
  }
}
